import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
  styled,
  lighten,
} from "@material-ui/core/styles";
import { BreadcrumbPage } from "../../shared";
import { useDispatch } from 'react-redux';
import { getDefaultTabName } from "../../services/FunctionServices";
import ReportStatus from "./ReportStatus";
import moment from 'moment';
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTotDate } from "../../services/DateServices";
import { SampleStatusData, ReportStatusColor, TotalSampleStatusData, TotalReportStatusData, SampleStatusColor } from "./ReportStatusInstantiation";
import { reportObj, reportFualObjSample, reportLubeObjSample, reportTotObjSample, sampleObj, sampleFualObjSample, sampleLubeObjSample, sampleTotObjSample, equipmentList, LubeList } from "./ReportObj"
import clsx from "clsx";
import { getCookie } from "../../services/Cookies";
import grey from "@material-ui/core/colors/grey";
import { getRequest, postRequest } from "../../services/ApiServices";
import axios from "axios";
import { LOADING } from '../../action';
import { ToastError } from "../../services/ToastMsg";
import ReportFormat from "./ReportFormat";
import IconButton from "@material-ui/core/IconButton";
import { TableFilterList } from "mui-datatables";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import reset from '../Helpsection_images/reset.jpg';
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import fuel_progressbar from '../Helpsection_images/fuel_progressbar.jpg';
import lube_progressbar from '../Helpsection_images/lube_progressbar.jpg';
import trans_progressbar from '../Helpsection_images/trans_progressbar.jpg';
import pdficon from '../Helpsection_images/pdficon.jpg';
import downloadpdf from '../Helpsection_images/downloadpdf.jpg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Help from "@material-ui/icons/Help";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import FiltersReportFuel from "./FiltersReportFuel";
import FiltersReportLube from "./FiltersReportLube";
import FiltersReportTot from "./FiltersReportTot";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: "#fff",
  },
  body: {},

}))(TableCell);
const useStyles = makeStyles((theme) => ({
  text: {
    paddingLeft: 20
  },

  roundBox: {
    borderRadius: "50%",
    border: "6px solid #000",
    height: "130px",
    width: "130px",
    textAlign: "center",
  },
  boxShadow_0: {
    boxShadow: "0 0 0 #fff !important",
  },
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 17
    }
  },

  link: {
    fontSize: "20px",
    textDecoration: "none",
    background: "white",
    color: 'white',
    border: "white",
  },
  reportDescriptionHover: {
    color: 'white',
    background: "white",
    width: 'auto',
    height: 'auto',
    border: 'none',
    fontSize: "8px",
    '&:hover': {
      textDecoration: "none",
      cursor: "pointer",
      background: "white",
      width: "auto",
      height: 'auto',
      border: 'none',
      color: 'black',
      fontSize: "8px",
      fontWeight: "bold"
    },
  },
  btnStyle3: {
    color: "#ff4717",
    boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
    marginLeft: "15px",
    padding: "8px 8px",
    marginLeft: "18px",
    cursor: "pointer",
  },
  DoawnloadButton: {
    marginRight: "200px"
  }
}));

export default function Reports(props) {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Reports", url: "" }];
  const [scroll, setScroll] = React.useState('paper');
  const [openformFuel, setOpenformFuel] = React.useState(false);
  const [openformLube, setOpenformLube] = React.useState(false);
  const [openformTot, setOpenformTot] = React.useState(false);
  const [clearBarSelection, setClearBarSelection] = useState(true);
  const [reportData, setReportData] = useState([]);
  const [selectedreportDataFuel, setSelectedReportDataFuel] = useState([]);
  const [selectedreportDataLube, setSelectedReportDataLube] = useState([]);
  const [selectedreportDataTot, setSelectedReportDataTot] = useState([]);
  const [filterStatus, setFilterStatus] = useState(false);
  const [isEmpty, setEmpty] = useState(false);
  const [ClearProgressBar, setClearProgressBar] = useState()
  const [DataProgressBar, setDataProgressBar] = useState()
  const [filterChip, setFilterChip] = useState();

  const [reportDetailsList, setReportDetailsList]
    = useState({
      fuelAnalysisSampleStatus: [], lubeAnalysisSampleStatus: [], totAnalysisSampleStatus: [],
      fuelAnalysisReportStatus: [], lubeAnalysisReportStatus: [], totAnalysisReportStatus: []
    });
  const [reportDetailsListTotal, setReportDetailsListTotal]
    = useState([]);
  const [reportFormatActive, setReportFormatActive]
    = useState({});
  const dispatch = useDispatch();
  const [reporSubType, setReporSubType] = useState(props.location.subType? props.location.subType: getDefaultTabName()[0]);
  const [reportType, setReportType] = useState(props?.location?.type || "ReportStatus");
  const [DataName, settabName] = React.useState()
  const [globalFilterObj, setGlobalFilterObj] = useState({});
  const [grouping, setGrouping] = useState(getCookie('grouping'));

  const handleClickOpen = () => {
    if (reporSubType == "Fuel" && reportType == "ReportStatus") {
      setOpenformFuel(true);
    }
    if (reporSubType == "Lube" && reportType == "ReportStatus") {
      setOpenformLube(true);
    }
    if (reporSubType == "Tot" && reportType == "ReportStatus") {
      setOpenformTot(true);
    }
  };

  const handleClickClose = () => {
    setOpenformFuel(false);
  };
  const handleClickCloseLube = () => {
    setOpenformLube(false);
  };
  const handleClickCloseTot = () => {
    setOpenformTot(false);
  };

  const IntialPageLoading = () => {

    if (reporSubType == "Fuel") {
      IntialFuelLoadEffect()
    }
    else if (reporSubType == "Lube") {
      IntialLubeLoadEffect()
    }
    else {
      IntialTotLoadEffect()
    }
  }
  useEffect(() => {


    IntialPageLoading()
    loadAPIData();
  }, []);
  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    },
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: "450px",
          }
        }
      }
    },
  })

  const IntialFuelLoadEffect = () => {

    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj
      }
      let ReportStartDate = (Obj.Fqtreportstartdate && Obj.Fqtreportstartdate[0] ? Obj.Fqtreportstartdate[0] : Obj.Fqtreportstartdate);
      let ReportEndDate = (Obj.Fqtreportenddate && Obj.Fqtreportenddate[0] ? Obj.Fqtreportenddate[0] : Obj.Fqtreportenddate)
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      else {
        let dt = getDefaultFuelDate();
        JSONFormat.ReportedDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
        if (getCookie('historicvessels') === 'true') {
          JSONFormat.HistoricVessel = true;
        } else {
          JSONFormat.HistoricVessel = false;
        }
      }
      filterReportFual(JSONFormat);

    }
    else {
      let JSONFormat = {};
      let dt = getDefaultFuelDate();
      JSONFormat.ReportedDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      filterReportFual(JSONFormat);
    }
  }
  const IntialLubeLoadEffect = () => {

    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj,

      }
      let ReportStartDate = (Obj.lubereportstartdate && Obj.lubereportstartdate[0] ? Obj.lubereportstartdate[0] : Obj.lubereportstartdate);
      let ReportEndDate = (Obj.lubereportenddate && Obj.lubereportenddate[0] ? Obj.lubereportenddate[0] : Obj.lubereportenddate)
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      else {
        let dt = getDefaultLubeDate();
        JSONFormat.ReportedDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
        if (getCookie('historicvessels') === 'true') {
          JSONFormat.HistoricVessel = true;
        } else {
          JSONFormat.HistoricVessel = false;
        }
      }
      filterReportLube(JSONFormat);

    } else {
      let JSONFormat = {};
      let dt = getDefaultLubeDate();
      JSONFormat.ReportedDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      filterReportLube(JSONFormat);
    }
  }
  const IntialTotLoadEffect = () => {
    
    let getCookieval = "";
    if (localStorage.getItem('TOTFilterSetting') !== "" && localStorage.getItem('TOTFilterSetting') !== undefined && localStorage.getItem('TOTFilterSetting') !== null && localStorage.getItem('TOTFilterSetting') !== "null") {
      getCookieval = localStorage.getItem('TOTFilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj,

      }
      let ReportStartDate = (Obj.Totreportstartdate && Obj.Totreportstartdate[0] ? Obj.Totreportstartdate[0] : Obj.Totreportstartdate);
      let ReportEndDate = (Obj.Totreportenddate && Obj.Totreportenddate[0] ? Obj.Totreportenddate[0] : Obj.Totreportenddate)
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      else {
        let dt = getDefaultTotDate();
        JSONFormat.ReportedDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
        if (getCookie('historicvessels') === 'true') {
          JSONFormat.HistoricVessel = true;
        } else {
          JSONFormat.HistoricVessel = false;
        }
      }
      filterReportTot(JSONFormat);

    }
    else {
      let JSONFormat = {};
      let dt = getDefaultTotDate();
      JSONFormat.ReportedDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      filterReportTot(JSONFormat);
    }
  }

  const getcurrentDateByReportSubType = (type) => {

    if (type == "Fuel") {
      return getCurrentDateOfBelow(90)
    } else if (type == "Lube") {
      return getCurrentDateOfBelow(180)
    } else if (type == "Tot") {
      return getCurrentDateOfBelow(730)
    }
  }

  const loadAPIData = async () => {
    if (getCookie('serviceTypes') !== 'BQS') {
      //await getReports(getCookie("clientId"));
    }
    // if (reporSubType == "Fuel" && reportType == "SampleStatus") {
    //     if (getCookie('serviceTypes') !== 'BQS') {
    //         await getReportFualDrillDown("Report/FuelAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Fuel");
    //     } else {
    //         let data = {
    //             "reportedFromDate": getCurrentDateOfBelow(30),
    //             "reportedToDate": getCurrentDate()
    //         }
    //         await filterSampleFuel(data);
    //     }
    // }
    if (reporSubType == "Fuel" && reportType == "ReportStatus") {
      if (getCookie('serviceTypes') !== 'BQS') {
        //settabName("Fuel")
        //await getReportFualDrillDown("Report/FuelAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Fuel");
      } else {
        //settabName("Fuel")
        let data = {
          "reportedFromDate": getCurrentDateOfBelow(30),
          "reportedToDate": getCurrentDate()
        }
        //await filterReportFual(data);
      }
    }
    if (reporSubType == "Lube" && reportType == "SampleStatus") {
      //await getReportFualDrillDown("Report/LubeAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Lube");
    }
    if (reporSubType == "Lube" && reportType == "ReportStatus") {
      //settabName("Lube")

      //await getReportFualDrillDown("Report/LubeAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Lube");
    }
    if (reporSubType == "Tot" && reportType == "SampleStatus") {
      await getReportFualDrillDown("Report/ToTAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Tot");
    }
    if (reporSubType == "Tot" && reportType == "ReportStatus") {
      //settabName("Tot")
      // await getReportFualDrillDown("Report/ToTAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Tot");
    }
  }
  const filterReportFual = async (formObj) => {
    debugger
    setFilterChip(true)
    if (formObj.Fqtreportstatus && formObj.Fqtreportstatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    setReportData([]);
    setGlobalFilterObj(formObj);
    let filterObj = {};
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.Fqtreportstatus && formObj.Fqtreportstatus.length > 0) { filterObj = { ...filterObj, Fqtreportstatus: formObj.Fqtreportstatus } }
    if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
    if (formObj.Fqtbunkerport && formObj.Fqtbunkerport.length > 0) { filterObj = { ...filterObj, Fqtbunkerport: formObj.Fqtbunkerport } }
    if (formObj.FqtSupplier && formObj.FqtSupplier.length > 0) { filterObj = { ...filterObj, FqtSupplier: formObj.FqtSupplier } }
    if (formObj.Fqtbargename && formObj.Fqtbargename.length > 0) { filterObj = { ...filterObj, Fqtbargename: formObj.Fqtbargename } }
    if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
    if (formObj.Fqtsamplenumber && formObj.Fqtsamplenumber.length > 0) { filterObj = { ...filterObj, Fqtsamplenumber: formObj.Fqtsamplenumber } }
    if (formObj.Fqtfuelgrade && formObj.Fqtfuelgrade.length > 0) { filterObj = { ...filterObj, Fqtfuelgrade: formObj.Fqtfuelgrade } }
    if (formObj.FqtOffSpec && formObj.FqtOffSpec.length > 0) { filterObj = { ...filterObj, FqtOffSpec: formObj.FqtOffSpec } }
    if (formObj.Fqtlab && formObj.Fqtlab.length > 0) { filterObj = { ...filterObj, Fqtlab: formObj.Fqtlab } }
    if (formObj.ReportedDate) { filterObj = { ...filterObj, ReportedDate: formObj.ReportedDate } }
    let Data = {};
    if (formObj.ReportedDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj

      JSONFormat = { ...filterObj }
      let ReportStartDate = (formObj.Fqtreportstartdate[0].startDate ? formObj.Fqtreportstartdate[0].startDate : formObj.Fqtreportstartdate[0]);
      let ReportEndDate = (formObj.Fqtreportenddate[0].endDate ? formObj.Fqtreportenddate[0].endDate : formObj.Fqtreportenddate[0])
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/FuelAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        res.data.fuelAnalysisReportStatus_data.forEach((d) => {
          d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
          d.bunkeringDt = moment(d.bunkeringDt).format('DD/MM/YYYY');
        })
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.fuelAnalysisReportStatus_data) {
          setReportData(getReportFualFormat(res.data.fuelAnalysisReportStatus_data));
        }
        if (res.data.fuelAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.fuelAnalysisReportStatus_chart));

          const objData = { fuelAnalysisReportStatus: getReportData(res.data.fuelAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { fuelAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterReportLube = async (formObj) => {
    setFilterChip(true);
    if (formObj.lubereportstatus && formObj.lubereportstatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    setReportData([]);
    let filterObj = {};
    setGlobalFilterObj(formObj);
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
    if (formObj.lobrand && formObj.lobrand.length > 0) { filterObj = { ...filterObj, lobrand: formObj.lobrand } }
    if (formObj.lograde && formObj.lograde.length > 0) { filterObj = { ...filterObj, lograde: formObj.lograde } }
    if (formObj.lubeequipname && formObj.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: formObj.lubeequipname } }
    if (formObj.lubeequipmodel && formObj.lubeequipmodel.length > 0) { filterObj = { ...filterObj, lubeequipmodel: formObj.lubeequipmodel } }
    if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
    if (formObj.lubelab && formObj.lubelab.length > 0) { filterObj = { ...filterObj, lubelab: formObj.lubelab } }
    if (formObj.lubeequipmake && formObj.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: formObj.lubeequipmake } }
    if (formObj.lubereportstatus && formObj.lubereportstatus.length > 0) { filterObj = { ...filterObj, lubereportstatus: formObj.lubereportstatus } }
    if (formObj.ReportedDate) { filterObj = { ...filterObj, ReportedDate: formObj.ReportedDate } }
    let Data = {};
    if (formObj.ReportedDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj
      JSONFormat = { ...filterObj }
      let ReportStartDate = (formObj.lubereportstartdate[0].startDate ? formObj.lubereportstartdate[0].startDate : formObj.lubereportstartdate[0]);
      let ReportEndDate = (formObj.lubereportenddate[0].endDate ? formObj.lubereportenddate[0].endDate : formObj.lubereportenddate[0]);
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });

    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/LubeAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        res.data.lubeAnalysisReportStatus_data.forEach((d) => {
          d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
        })
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.lubeAnalysisReportStatus_data) {
          console.log("Lube analysis report data", res.data.lubeAnalysisReportStatus_data);

          setReportData(getReportLubeFormat(res.data.lubeAnalysisReportStatus_data));
        }
        if (res.data.lubeAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.lubeAnalysisReportStatus_chart));

          const objData = { lubeAnalysisReportStatus: getReportData(res.data.lubeAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        console.log("fuel report data", reportData);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { lubeAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });


  }
  const filterReportTot = async (formObj) => {
    debugger
    setFilterChip(true)
    if (formObj.Totreportstatus && formObj.Totreportstatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    setReportData([]);
    let filterObj = {};
    setGlobalFilterObj(formObj);
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.Totserialnumber && formObj.Totserialnumber.length > 0) { filterObj = { ...filterObj, Totserialnumber: formObj.Totserialnumber } }
    if (formObj.Totclientcontract && formObj.Totclientcontract.length > 0) { filterObj = { ...filterObj, Totclientcontract: formObj.Totclientcontract } }
    if (formObj.Totlocation && formObj.Totlocation.length > 0) { filterObj = { ...filterObj, Totlocation: formObj.Totlocation } }
    if (formObj.Totmanufacture && formObj.Totmanufacture.length > 0) { filterObj = { ...filterObj, Totmanufacture: formObj.Totmanufacture } }
    if (formObj.Totvoltage && formObj.Totvoltage.length > 0) { filterObj = { ...filterObj, Totvoltage: formObj.Totvoltage } }
    if (formObj.Totreportstatus && formObj.Totreportstatus.length > 0) { filterObj = { ...filterObj, Totreportstatus: formObj.Totreportstatus } }
    if (formObj.Totsamplenumber && formObj.Totsamplenumber.length > 0) { filterObj = { ...filterObj, Totsamplenumber: formObj.Totsamplenumber } }
    if (formObj.TotRating && formObj.TotRating.length > 0) { filterObj = { ...filterObj, TotRating: formObj.TotRating } }
    if (formObj.TotSubCustomerName && formObj.TotSubCustomerName.length > 0) { filterObj = { ...filterObj, TotSubCustomerName: formObj.TotSubCustomerName } }
    if (formObj.Totlab && formObj.Totlab.length > 0) { filterObj = { ...filterObj, Totlab: formObj.Totlab } }
    if (formObj.TotUnitDescription && formObj.TotUnitDescription.length > 0) { filterObj = { ...filterObj, TotUnitDescription: formObj.TotUnitDescription } }
    if (formObj.ReportedDate) { filterObj = { ...filterObj, ReportedDate: formObj.ReportedDate } }

    let Data = {};
    if (formObj.ReportedDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj
      let ReportStartDate = (formObj.Totreportstartdate[0].startDate ? formObj.Totreportstartdate[0].startDate : formObj.Totreportstartdate[0]);
      let ReportEndDate = (formObj.Totreportenddate[0].endDate ? formObj.Totreportenddate[0].endDate : formObj.Totreportenddate[0])
      JSONFormat = {
        ...filterObj
      }
      if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
        JSONFormat.ReportedDate = {
          startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
          endDate: moment(ReportEndDate).format('YYYY/MM/DD')
        };
      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/ToTAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        res.data.toTAnalysisReportStatus_data.forEach((d) => {
          d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
        })
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.toTAnalysisReportStatus_data) {
          setReportData(getReportTotFormat(res.data.toTAnalysisReportStatus_data));
        }
        if (res.data.toTAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.toTAnalysisReportStatus_chart));
          const objData = { totAnalysisReportStatus: getReportData(res.data.toTAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { totAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }

  const FormatClearFilter = (Obj) => {
    //
    if (reporSubType == "Fuel") {
      let FuelProgressBar = ""
      let FuelProgresstate = ""
      if (Obj.Fqtreportstatus.length) {
        FuelProgressBar = Obj.Fqtreportstatus[0].name ? true : false
        FuelProgresstate = Obj.Fqtreportstatus[0].name
      }
      setClearProgressBar(FuelProgressBar)
      setDataProgressBar(FuelProgresstate)
    }
    else if (reporSubType == "Lube") {
      let LubeProgressBar = ""
      let LubeProgresstate = ""
      if (Obj.lubereportstatus.length) {
        LubeProgressBar = Obj.lubereportstatus[0].name ? true : false
        LubeProgresstate = Obj.lubereportstatus[0].name
      }
      setClearProgressBar(LubeProgressBar)
      setDataProgressBar(LubeProgresstate)
    }
    else if (reporSubType == "Tot") {
      let TotProgressBar = ""
      let TotProgresstate = ""
      if (Obj.Totreportstatus.length) {
        TotProgressBar = Obj.Totreportstatus[0].name ? true : false
        TotProgresstate = Obj.Totreportstatus[0].name
      }
      setClearProgressBar(TotProgressBar)
      setDataProgressBar(TotProgresstate)
    }
  }
  const Resetclearprogressbar = () => {
    //
    setClearProgressBar(false)
  }
  const clearFilter = () => {
    loadAPIData();
    setEmpty(true);
  }
  const getReportFualDrillDown = async (urlType, customerKeys, subType) => {
    debugger
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `${urlType}`;

    const data = {
      "CustomerKeys": customerKeys,
      "FuelStartDate": getcurrentDateByReportSubType(subType),
      "FuelEndDate": getCurrentDate(),
      "LubeStartDate": getcurrentDateByReportSubType(subType),
      "LubeEndDate": getCurrentDate(),
      "TotStartDate": getcurrentDateByReportSubType(subType),
      "TotEndDate": getCurrentDate()
    }
    await postRequest(url, data)
      .then((res) => {

        console.log("sample-type", subType, res.data);
        if (subType == "Fuel" && reportType == "ReportStatus") {
          setReportData(getReportFualFormat(res.data));
        }
        // if (subType == "Fuel" && reportType == "SampleStatus") {
        //     setReportData(getSampleFualFormat(res.data));
        // }
        if (subType == "Lube" && reportType == "ReportStatus") {
          setReportData(getReportLubeFormat(res.data));
        }
        // if (subType == "Lube" && reportType == "SampleStatus") {
        //     setReportData(getSampleLubeFormat(res.data));
        // }
        if (subType == "Tot" && reportType == "ReportStatus") {
          //
          setReportData(getReportTotFormat(res.data));
        }
        // if (subType == "Tot" && reportType == "SampleStatus") {
        //     setReportData(getSampleTotFormat(res.data));
        // }

        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const getReportFualFormat = (data) => {
    return data;
  }
  const getReportLubeFormat = (data) => {
    //
    //return data
    if (data.length) {
      let existLubeArr = [];
      let listOfLube = [];
      //debugger
      (grouping == "false" ?
        data.map((row) => {
          let LubeResIndex = existLubeArr.indexOf(row.pdfFileName);
          if (LubeResIndex > -1) {
            let subObj = {
              ...equipmentList,
              SampleId: row?.sampleControlNoCd,
              Equipment: row.equipmentDescription,
              Make: row.make,
              Model: row.model,
              lobrand: row.sampleLubeBrand,
              status: row.status,
              reportDt: row.reportDt
            }
            listOfLube[LubeResIndex].EquipmentList.push(subObj);

          } else {
            existLubeArr.push(row.pdfFileName);
            let subObj = {
              ...equipmentList,
              SampleId: row.sampleControlNoCd,
              Equipment: row.equipmentDescription,
              Make: row.make,
              Model: row.model,
              lobrand: row.sampleLubeBrand,
              status: row.status,
              reportDt: row.reportDt
            }
            let obj = {
              ...LubeList,
              ShipName: row?.vesselId + " (" + row?.imoNo + ")",
              contractNumber: row.axContractId,
              serviceType: row.serviceType,
              pdfFileName: row.pdfFileName,
              EquipmentList: [subObj],
              reportDt: row.reportDt?.split("T")[0],
              customerName: row?.customerName
            }
            listOfLube.push(obj);
            //console.log("List of Lube : ", listOfLube);
          }
        })
        : listOfLube = data)
      //setSchedulerList(listOfLube);
      return listOfLube;
    }


  }
  const getReportTotFormat = (data) => {
    return data;
  }
  const tabReportActive = (index) => {
    if (filterStatus) {
      setFilterStatus(false);
      //getReports(getCookie("clientId"));
    }
    setReportFormatActive(reportDetailsListTotal[index]);
    if (index == 0) {
      //
      settabName("Fuel")
      setReporSubType("Fuel");
      /* setFormObj(reportFilterFuel)
      filterReportFual(reportFilterFuel) */
      filterReportFual(IntialFuelLoadEffect())

      //getReportFualDrillDown("Report/FuelAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Fuel");
    } if (index == 1) {
      //
      setReporSubType("Lube");
      settabName("Lube")
      /* setFormObj(reportFilterLube)
      filterReportLube(reportFilterLube) */
      filterReportLube(IntialLubeLoadEffect())

      //getReportFualDrillDown("Report/LubeAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Lube");
    } if (index == 2) {
      //
      setReporSubType("Tot");
      settabName("Tot")
      /* setFormObj(reportFilterTot)
      filterReportTot(reportFilterTot) */
      filterReportTot(IntialTotLoadEffect())
      //getReportFualDrillDown("Report/ToTAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Tot");
    }
  }
  const getReportData = (data) => {
    //
    let analysList = [];
    let analysServiceList = [];
    let analysStatusList = [];
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.map((row, index) => {
      ////console.log(index, row);
      const reportIndex = analysServiceList.indexOf(row.serviceType.trim());
      if (reportIndex > -1) {
        const IndexForStatus = analysStatusList[reportIndex].indexOf(row.status);
        if (IndexForStatus > -1) {
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[IndexForStatus],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        } else {
          analysStatusList[reportIndex].push(row.status);
          const analysStatusListIndex = analysStatusList[reportIndex].indexOf(row.status);
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[analysStatusListIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        }
      } else {
        analysServiceList.push(row.serviceType.trim());
        const IndexForStatus = analysServiceList.indexOf(row.serviceType.trim());
        const arrStatus = [];
        arrStatus.push(row.status)
        analysStatusList[IndexForStatus] = arrStatus;
        const analysStatusListIndex = analysStatusList[IndexForStatus].indexOf(row.status);
        const samplePipeData = {
          "title": row.status,
          "color": ReportStatusColor[analysStatusListIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        }
        let SampleStatusFormatData = [];
        SampleStatusFormatData.push(samplePipeData);
        const SampleStatusDataEdit = { ...SampleStatusData, caseCount: row.samplesCount, title: row.serviceType, typeOfCase: SampleStatusFormatData }
        analysList.push(SampleStatusDataEdit);
      }
    })
    return analysList;
  }
  const getReportTotalData = (data) => {
    //
    let analysList = [];
    let analysStatusList = [];
    let countCase = 0;
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        countCase = countCase + row.samplesCount;
        analysList.push({
          "title": row.status,
          "color": ReportStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    return { ...TotalReportStatusData, caseCount: countCase, typeOfCase: analysList };
  }
  // const getDownload = (data) => {
  //     //debugger
  //     ////console.log(data);
  //     if (data.pdfFileName) {
  //         dispatch({ type: LOADING, payload: true });
  //         const token = getCookie("token");
  //         let fileName = data.pdfFileName;
  //         if (data.pdfFileName.indexOf("\\") > -1) {
  //             fileName = data.pdfFileName.split("\\")[1];
  //         }
  //         const url =
  //             process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/file`;
  //         let filedata = JSON.stringify({ fileName: fileName });
  //         let config = {
  //             method: "post",
  //             responseType: "blob",
  //             url: url,
  //             headers: {
  //                 Authorization: `Bearer ${token}`,
  //                 "Content-Type": "application/json",
  //                 Accept: "application/pdf"
  //             },
  //             data: filedata,
  //         };
  //         axios(config)
  //             .then(async function (response) {
  //                 if (response.status == 200) {
  //                     dispatch({ type: LOADING, payload: false });
  //                     const file = new Blob([response.data], { type: "application/pdf" });
  //                     //Build a URL from the file
  //                     const fileURL = URL.createObjectURL(file);
  //                     console.log(fileURL);
  //                     // window.open(fileURL, '_blank')
  //                     // window.location = fileURL;
  //                 } else {
  //                     ToastError(response.data.message);
  //                 }
  //             })
  //             .catch(function (error) {
  //                 dispatch({ type: LOADING, payload: false });
  //                 ////console.log(error);
  //             });
  //     }
  // }
  const [fName, setFName] = useState("");
  const [openpdf, setOpenpdf] = React.useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [openAlert, setOpenAlert] = React.useState(false);
  const getRowPDFDownload = (row) => {
    //////console.log(data);
    ////
    const pdfFileName = row
    if (pdfFileName) {
      dispatch({ type: LOADING, payload: true });
      const token = getCookie("token");
      let fileName = pdfFileName;
      if (pdfFileName.indexOf("\\") > -1) {
        fileName = pdfFileName.split("\\")[1];
      }
      const url =
        process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/file`;
      let filedata = JSON.stringify({ fileName: fileName });
      let config = {
        method: "post",
        responseType: "blob",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/pdf"
        },
        data: filedata,
      };
      axios(config)
        .then(async function (response) {
          if (response.status == 200) {
            dispatch({ type: LOADING, payload: false });
            const file = new Blob([response.data], { type: "application/pdf" });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            setPdfURL(fileURL);
            //window.open(fileURL, '_blank')
            // window.location = fileURL;
          } else {
            ToastError(response.data.message);
          }
        })
        .catch(function (error) {
          dispatch({ type: LOADING, payload: false });
          ////console.log(error);
        });
    }
  }
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: "strong",
      border: '1px solid #dadde9',
    },
  }));
  const getpdfName = (value) => {
    setFName(value);
  }
  const getLubepdfName = (value) => {
    let val = reportData[value.index]
    if (val.serviceType === "OCM" && (val.EquipmentList).length === 1) {
      // getpdfName(value.EquipmentList[0].Equipment + " (" + value.EquipmentList[0].SampleId + ")-VPS OCM Report-" + value.reportDt)
      // getpdfName(value.ShipName + "-VPS OCM Report (" + (value.EquipmentList).length + " )_Rev1-" + value.reportDt)
      getpdfName(val.ShipName + "-VPS OCM Report-" + (val.EquipmentList).length + val.reportDt)
    } else if (val.serviceType === "OCM") {
      getpdfName(val.ShipName + "-VPS OCM Report (" + (val.EquipmentList).length + " nos)_Rev1-" + val.reportDt)
    } else {
      getpdfName(val.ShipName + "-VPS SDA Report-" + val.reportDt)
    }
  }
  const toggleRow = (row) => {
    //debugger
    /* setOpen(!open);
   if(!open && !pdfURL) */
    setPdfURL(null);
    getRowPDFDownload(row)
    setOpenAlert(true);
    setOpenpdf(true)
  }
  const handleClose = () => {
    //debugger
    setOpenAlert(false);
    setOpenpdf(false);
  };
  const [tab, setTab] = React.useState();

  const getChangedTab = (t) => {
    setTab(t);
  }

  const getPDFButton = (data) => {
    if (data.serviceType === "TOT") {
      return (<HtmlTooltip
        title={
          <React.Fragment>
            Download Reports
          </React.Fragment>
        }
      ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.pdfFileName); getpdfName(data.sampleControlNoCd + "_" + data.tranformerName) }}>
          <img src="/assets/images/F-icon.png" style={{ width: "20px" }} value={data.pdfFileName} />
        </button></HtmlTooltip>);
    } else if (data.pdfDocumentType === "SPEC") {
      return (<HtmlTooltip
        title={
          <React.Fragment>
            Download Reports
          </React.Fragment>
        }
      ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.pdfFileName); getpdfName(data.sampleControlNoCd + "_" + data.currentVesselName + "_" + "Spec") }}>
          <img src="/assets/images/S-icon.png" style={{ width: "20px" }} value={data.pdfFileName} />
        </button></HtmlTooltip>);
    } else if (data.sampleControlNoCd === null) {
      return (<HtmlTooltip
        title={
          <React.Fragment>
            Download Reports
          </React.Fragment>
        }
      ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.pdfFileName); getpdfName(data.currentVesselName) }}>
          <img src="/assets/images/F-icon.png" style={{ width: "20px" }} value={data.pdfFileName} />
        </button></HtmlTooltip>);
    } else if (data.currentVesselName === null) {
      return (<HtmlTooltip
        title={
          <React.Fragment>
            Download Reports
          </React.Fragment>
        }
      ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.pdfFileName); getpdfName(data.sampleControlNoCd) }}>
          <img src="/assets/images/F-icon.png" style={{ width: "20px" }} value={data.pdfFileName} />
        </button></HtmlTooltip>);
    } else {
      return (<HtmlTooltip
        title={
          <React.Fragment>
            Download Reports
          </React.Fragment>
        }
      ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.pdfFileName); getpdfName(data.sampleControlNoCd + "_" + data.currentVesselName) }}>
          <img src="/assets/images/F-icon.png" style={{ width: "20px" }} value={data.pdfFileName} />
        </button></HtmlTooltip>);
    }

  }
  const getPDFButton1 = (data) => {
    return (<HtmlTooltip
      title={
        <React.Fragment>
          Download Reports
        </React.Fragment>
      }
    ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.additionalOAFile); getpdfName(data.sampleControlNoCd + "_" + data.currentVesselName + "_" + "Operational") }}>
        <img src="/assets/images/O-icon.png" style={{ width: "20px" }} value={data.additionalOAFile} />
      </button></HtmlTooltip>);

  }
  const getPDFButton2 = (data) => {
    return (<HtmlTooltip
      title={
        <React.Fragment>
          Download Reports
        </React.Fragment>
      }
    ><button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { toggleRow(data.additionalSPECFile); getpdfName(data.sampleControlNoCd + "_" + data.currentVesselName + "_" + "Spec") }}>
        <img src="/assets/images/S-icon.png" style={{ width: "20px" }} value={data.additionalSPECFile} />
      </button></HtmlTooltip>);

  }
  const getReportsColumn = (data) => {
    //console.log("rowData:", data);

    let additionalOAFile, AdditionalSPECFile, PDFFileName;
    PDFFileName = (data.pdfFileName != null ? getPDFButton(data) : <></>);
    additionalOAFile = (data.additionalOAFile != null ? getPDFButton1(data) : <></>);

    AdditionalSPECFile = (data.additionalSPECFile != null ? getPDFButton2(data) : <></>);


    return <div class="row">{PDFFileName}{additionalOAFile}{AdditionalSPECFile}</div>

  }

  const getGridHeader2 = (reportSubTypeV) => {
    if (reportSubTypeV == "Fuel") {
      //if (reportData) { }
      return [
        {
          name: "bunkeringDt",
          label: "Bunkered Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "currentVesselName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "portName",
          label: "Bunkered Port ",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "productType",
          label: "Fuel Grade",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "axContractId",
          label: "Customer Contract ",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "reportDt",
          label: "Report Date ",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "status",
          label: "Status ",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "additionalOAFile",
          label: " Reports  Description",
          options: {
            filter: false,
            sort: true,
            download: false,
            customBodyRender: (Value, tableMeta) => {
              // debugger
              console.log("table", tableMeta);
              return getReportsColumn(reportData[tableMeta.currentTableData[tableMeta.rowIndex].index])
            }

          }
        },
      ];
    } else if (reportSubTypeV == "Lube") {
      return [
        {
          name: "ShipName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "customerName",
          label: "Customer",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "reportDt",
          label: "Report Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "serviceType",
          label: "Report Type",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,
            display: 'excluded',


          }
        },

        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,
            sort: true,
            customBodyRender: (Value, tableMeta) => {
              //
              return (
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      Download Reports
                    </React.Fragment>
                  }
                >
                  <button className={classes.link} onClick={() => { toggleRow(Value); getLubepdfName(tableMeta.currentTableData[tableMeta.rowIndex]) }}>
                    <img src="/assets/images/F-icon.png"
                      style={{ width: "20px" }}
                      value={Value} />
                  </button>
                </HtmlTooltip>)
              //return getReportsColumn(reportData[tableMeta.rowIndex])
              //<PictureAsPdfSharpIcon style={{ align: "center" }} value={Value} />

            }

          }
        },
      ];
    } else if (reportSubTypeV == "Tot") {
      return [
        {
          name: "reportDt",
          label: "Report Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "tranformerName",
          label: "Asset Name",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "sampleControlNoCd",
          label: "	Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "axContractId",
          label: "	Customer Contract ",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "serviceType",
          label: "Service Type",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "status",
          label: "	Flag ",
          options: {
            filter: true,
            sort: true,
            // style={getFlagColor(item.status)}

          }
        },
        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,
            sort: true,
            download: false,
            customBodyRender: (Value, tableMeta) => {
              //return <button className={classes.link} onClick={() => { toggleRow(Value) }}><PictureAsPdfSharpIcon style={{ align: "center" }} value={Value} /> </button>
              return getReportsColumn(reportData[tableMeta.currentTableData[tableMeta.rowIndex].index])
            }

          }
        },
      ];
    }
  }

  const getGridHeader3 = (reportSubTypeV) => {
    //debugger
    if (reportSubTypeV == "Fuel") {
      //if (reportData) { }
      return [
        {
          name: "bunkeringDt",
          label: "Bunkered Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "currentVesselName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "portName",
          label: "Bunkered Port ",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "productType",
          label: "Fuel Grade",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "axContractId",
          label: "Customer Contract ",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "reportDt",
          label: "Report Date ",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "status",
          label: "Status ",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "additionalOAFile",
          label: " Reports  Description",
          options: {
            filter: false,
            sort: true,
            download: false,
            customBodyRender: (Value, tableMeta) => {
              // debugger
              console.log("table", tableMeta);
              return getReportsColumn(reportData[tableMeta.currentTableData[tableMeta.rowIndex].index])
              // return (<button className={classes.link + " " + classes.reportDescriptionHover} onClick={() => { toggleRow(Value) }}>
              //   <img src="/assets/images/F-icon.png"
              //     style={{ width: "20px" }}
              //     value={Value} />
              //   {' '} Download PDF report
              // </button>)

            }

          }
        },
      ];
    } else if (reportSubTypeV == "Lube") {
      return [
        {
          name: "vesselId",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "customerName",
          label: "Customer",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "reportDt",
          label: "Report Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "serviceType",
          label: "Report Type",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "equipmentDescription",
          label: "Equipment Description",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "make",
          label: "Make",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "model",
          label: "Model Number",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "sampleLubeBrand",
          label: "Lo Brand",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "status",
          label: "Status",
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => {
              // //
              if (value === "Satisfactory") {
                return <><span style={{ color: "#008000" }}>Satisfactory</span> </>
              } else if (value === "Critical") {
                return <><span style={{ color: "red" }}>Critical</span></>
              } else if (value === "Warning") {
                return <><span style={{ color: "#CA6F1E" }}>Warning</span></>
              } else if (value === "Other") {
                return <><span style={{ color: "#73C6B6" }}>Scheduled</span></>
              }
            }

          }
        },
        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,

            display: 'excluded',
            // customBodyRender: (Value, tableMeta) => {
            //   //return <button className={classes.link} onClick={() => { toggleRow(Value) }}><PictureAsPdfSharpIcon style={{ align: "center" }} value={Value} /> </button>
            //   return getReportsColumn(reportData[tableMeta.rowIndex])

            // }

          }
        },

        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,
            sort: true,
            customBodyRender: (Value, tableMeta) => {
              //
              return (
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      Download Reports
                    </React.Fragment>
                  }
                >
                  <button className={classes.link} onClick={() => { toggleRow(Value); getLubepdfName(tableMeta.currentTableData[tableMeta.rowIndex]) }}>
                    <img src="/assets/images/F-icon.png"
                      style={{ width: "20px" }}
                      value={Value} />
                  </button>
                </HtmlTooltip>)


            }

          }
        },

      ];
    } else if (reportSubTypeV == "Tot") {
      return [
        {
          name: "reportDt",
          label: "Report Date",
          options: {
            filter: true,
            sort: true,
          }
        }, {
          name: "tranformerName",
          label: "Asset Name",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "sampleControlNoCd",
          label: "	Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "axContractId",
          label: "	Customer Contract ",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "serviceType",
          label: "Service Type",
          options: {
            filter: true,
            sort: true,

          }
        }, {
          name: "status",
          label: "	Flag ",
          options: {
            filter: true,
            sort: true,
            // style={getFlagColor(item.status)}

          }
        },
        {
          name: "pdfFileName",
          label: "Report Description",
          options: {
            filter: false,
            sort: true,
            download: false,
            customBodyRender: (Value, tableMeta) => {
              //return <button className={classes.link} onClick={() => { toggleRow(Value) }}><PictureAsPdfSharpIcon style={{ align: "center" }} value={Value} /> </button>
              return getReportsColumn(reportData[tableMeta.currentTableData[tableMeta.rowIndex].index])
            }

          }
        },
      ];
    }
  }
  const CustomChip = ({ label, onDelete }) => {
    //
    return (
      <Chip
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    if (filterChip === true) {
      props.filterList.length = 0;
      setFilterChip(false)
    }
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  const toolTipValue = () => {

    if (grouping) {
      return "Ungrouping"
    } else {
      return "Grouping"
    }
  };

  const check = () => (
    <Tooltip disableFocusListener title={toolTipValue()} >
      <IconButton disabled  /*onClick={ReportLubeGrouping}*/ className={classes.btnStyle3} >
        {console.log(grouping)}
        {grouping == "true" ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
      </IconButton>
    </Tooltip>
  )

  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete:True,
      </>

    },
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    filter: true,
    filterType: 'multiselect',
    responsive: 'standard',
    customToolbar: (reporSubType === "Lube" ? check : ""),
    expandableRows: (reporSubType === "Lube" && grouping == "false" ? true : false),
    expandableRowsHeader: false,
    expandableRowsOnClick: (reporSubType === "Lube" ? true : false),
    download: true,
    downloadOptions: {
      filename: 'tableDownload.csv',
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true
      }
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      //debugger
      //console.log("reportlube", reportDatalube[]);
      let isExistFuel = [];
      let isExistLube = [];
      let isExistTot = [];

      rowsSelected.forEach((d) => {
        isExistFuel.push(reportData[d]);
        isExistLube.push(reportData[d]);
        isExistTot.push(reportData[d]);


      })
      //console.log("isExistFuel", isExistFuel)
      //console.log("shiva",isExist)
      setSelectedReportDataFuel(isExistFuel);
      setSelectedReportDataLube(isExistLube);
      setSelectedReportDataTot(isExistTot);

    },
    onDownload: (buildHead, buildBody, columns, gridData) => {
      if (grouping == "false") {
        if (reporSubType === "Lube") {
          var myData = [];
          console.log(reportData)
          var newKeys = Object.keys(reportData[0].EquipmentList[0]);
          var idx = 0;
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push(" ");
          columns.forEach((cl) => {
            if (cl.label !== "Report Description" && cl.label !== "Report Date")
              columnsExport.push(cl.label);
          })
          newKeys.forEach((k) => {
            columnsExport.push(k);
          });
          columnsExport.push("\n");
          columnsExport.splice(3, 0, columnsExport.splice(columnsExport.indexOf('Customer'), 1)[0]);
          let i = 0;
          selectedreportDataLube.length > 0 ?
            (
              selectedreportDataLube.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  console.log(dfdt)
                  if (dfdt[0] == item.ShipName && dfdt[1] == item.customerName && dfdt[2] == item.reportDt && dfdt[3] == item.serviceType && dfdt[4] == item.pdfFileName && dfdt[5] == item.pdfFileName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;
                  let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
                  itemEquipments.forEach((cl) => {
                    if (cl.Make !== null)
                      cl.Make = cl.Make.replace(/,/gi, ";");
                  })
                  delete itemData.pdfFileName;
                  delete itemData.reportDt;
                  delete itemData.contractNumber;
                  delete itemData.EquipmentList;
                  console.log(itemData)
                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            ) : (
              reportData.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  console.log(dfdt)
                  if (dfdt[0] == item.ShipName && dfdt[1] == item.customerName && dfdt[2] == item.reportDt && dfdt[3] == item.serviceType && dfdt[4] == item.pdfFileName && dfdt[5] == item.pdfFileName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;
                  let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
                  itemEquipments.forEach((cl) => {
                    if (cl.Make !== null)
                      cl.Make = cl.Make.replace(/,/gi, ";");
                  })
                  delete itemData.pdfFileName;
                  delete itemData.reportDt;
                  delete itemData.contractNumber;
                  delete itemData.EquipmentList;
                  console.log(itemData)
                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            )

          buildHead = () => {
            return columnsExport;
          }
          buildBody = () => {
            return myData;
          }
          return buildHead() + buildBody();

        }
      }
      else {
        if (reporSubType === "Lube") {
          var myData = [];
          console.log(reportData)
          //var newKeys = Object.keys(reportData[0].EquipmentList[0]);
          var idx = 0;
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push(" ");
          columns.forEach((cl) => {
            if (cl.label !== "Report Description")
              columnsExport.push(cl.label);
          })
          // newKeys.forEach((k) => {
          //   columnsExport.push(k);
          // });
          columnsExport.push("\n");
          //columnsExport.splice(3, 0, columnsExport.splice(columnsExport.indexOf('Customer'), 1)[0]);
          let i = 0;
          selectedreportDataLube.length > 0 ?
            (
              selectedreportDataLube.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  console.log(dfdt)
                  if (dfdt[0] == item.vesselId && dfdt[10] == item.pdfFileName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let objReportlube = {
                    shipnameImo: itemData.vesselId,
                    customerName: itemData.customerName,
                    reportDt: itemData.reportDt,
                    serviceType: itemData.serviceType,
                    sampleNumber: itemData.sampleControlNoCd,
                    equipmentdescription: itemData.equipmentDescription,
                    make: itemData.make,
                    modelnumber: itemData.model,
                    Lobrand: itemData.sampleLubeBrand,
                    status: itemData.status,
                  }
                  console.log(objReportlube)

                  //let di={index:idx++,data:[]}
                  let data = [];
                  data.push(...Object.values({ ...objReportlube }));
                  data.push("\n");
                  dataItem.push(data);

                  myData.push(...dataItem);
                }
              })) : (
              reportData.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  console.log(dfdt)
                  if (dfdt[0] == item.vesselId && dfdt[10] == item.pdfFileName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let objReportlube = {
                    shipnameImo: itemData.vesselId,
                    customerName: itemData.customerName,
                    reportDt: itemData.reportDt,
                    serviceType: itemData.serviceType,
                    sampleNumber: itemData.sampleControlNoCd,
                    equipmentdescription: itemData.equipmentDescription,
                    make: itemData.make,
                    modelnumber: itemData.model,
                    Lobrand: itemData.sampleLubeBrand,
                    status: itemData.status,
                  }
                  console.log(objReportlube)

                  //let di={index:idx++,data:[]}
                  let data = [];
                  data.push(...Object.values({ ...objReportlube }));
                  data.push("\n");
                  dataItem.push(data);

                  myData.push(...dataItem);
                }
              })
            )

          buildHead = () => {
            return columnsExport;
          }
          buildBody = () => {
            return myData;
          }
          return buildHead() + buildBody();
        }
      }
      if (reporSubType === "Fuel") {
        var myData = [];
        var newKeys = Object.keys(reportData[0]);
        var idx = 0;
        var columnsExport = [];
        var columnsExport1 = [];
        columnsExport.push("");
        columns.forEach((cl) => {
          //if(cl.label!=="Customer Contract")
          columnsExport.push(cl.label);

        })
        // newKeys.forEach((k) => {
        //   columnsExport.push(k);
        // });
        columnsExport.push("\n");
        let i = 0;

        //console.log(item);
        selectedreportDataFuel.length > 0 ?
          (
            selectedreportDataFuel.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.bunkeringDt && dfdt[1] == item.currentVesselName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.portName = itemData.portName.replace(/,/g, "");
                itemData.bunkeringDt = itemData.bunkeringDt ? itemData.bunkeringDt : "";
                itemData.reportDt = itemData.reportDt ? itemData.reportDt : "";

                let objReportfuel = {
                  bunkeringDt: itemData.bunkeringDt,
                  shipnameImo: itemData.currentVesselName,
                  portName: itemData.portName,
                  productType: itemData.productType,
                  sampleNumber: itemData.sampleControlNoCd,
                  CustomerContract: itemData.axContractId,
                  repordate: itemData.reportDt,
                  status: itemData.status,
                  status: itemData.status,
                  pdfFileName: itemData.pdfFileName
                }
                let data = [];
                data.push(...Object.values({ ...objReportfuel }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          ) : (

            reportData.forEach((item) => {
              debugger
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.bunkeringDt && dfdt[1] == item.currentVesselName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.portName = itemData.portName.replace(/,/g, "");
                itemData.bunkeringDt = itemData.bunkeringDt ? itemData.bunkeringDt : "";
                itemData.reportDt = itemData.reportDt ? itemData.reportDt : "";

                let objReportfuel = {
                  bunkeringDt: itemData.bunkeringDt,
                  shipnameImo: itemData.currentVesselName,
                  portName: itemData.portName,
                  productType: itemData.productType,
                  sampleNumber: itemData.sampleControlNoCd,
                  CustomerContract: itemData.axContractId,
                  repordate: itemData.reportDt,
                  status: itemData.status,
                  status: itemData.status,
                  pdfFileName: itemData.pdfFileName
                }
                let data = [];
                data.push(...Object.values({ ...objReportfuel }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          )
        buildHead = () => {
          console.log(columnsExport);
          return columnsExport;
        }
        buildBody = () => {
          // console.log(myData);
          return myData;
        }
        return buildHead() + buildBody();
      }
      if (reporSubType === "Tot") {
        debugger
        var myData = [];
        var newKeys = Object.keys(reportData[0]);
        console.log("reportData", reportData);
        var idx = 0;
        var columnsExport = [];
        var columnsExport1 = [];
        columnsExport.push("");
        columns.forEach((cl) => {
          //if(cl.label!=="Customer Contract")
          columnsExport.push(cl.label);

        })
        // newKeys.forEach((k) => {
        //   columnsExport.push(k);
        // });
        columnsExport.push("\n");
        let i = 0;

        //console.log(item);
        selectedreportDataTot.length > 0 ?
          (
            selectedreportDataTot.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.reportDt && dfdt[1] == item.tranformerName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.tranformerName = itemData.tranformerName.replace(/,/g, "");
                itemData.pdfFileName = itemData.pdfFileName.replace(/,/g, "");
                //itemData.bunkeringDt = itemData.bunkeringDt ? itemData.bunkeringDt : "";
                itemData.reportDt = itemData.reportDt ? itemData.reportDt : "";

                let objReportTot = {
                  reportDt: itemData.reportDt,
                  tranformerName: itemData.tranformerName,
                  sampleControlNoCd: itemData.sampleControlNoCd,
                  axContractId: itemData.axContractId,
                  serviceType: itemData.serviceType,
                  status: itemData.status,
                  pdfFileName: itemData.pdfFileName
                }
                let data = [];
                data.push(...Object.values({ ...objReportTot }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          ) : (

            reportData.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.reportDt && dfdt[1] == item.tranformerName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.tranformerName = itemData.tranformerName.replace(/,/g, "");
                itemData.pdfFileName = itemData.pdfFileName.replace(/,/g, "");
                //itemData.bunkeringDt = itemData.bunkeringDt ? itemData.bunkeringDt : "";
                itemData.reportDt = itemData.reportDt ? itemData.reportDt : "";

                let objReportTot = {
                  reportDt: itemData.reportDt,
                  tranformerName: itemData.tranformerName,
                  sampleControlNoCd: itemData.sampleControlNoCd,
                  axContractId: itemData.axContractId,
                  serviceType: itemData.serviceType,
                  status: itemData.status,
                  pdfFileName: itemData.pdfFileName
                }
                let data = [];
                data.push(...Object.values({ ...objReportTot }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          )
        buildHead = () => {
          console.log(columnsExport);
          return columnsExport;
        }
        buildBody = () => {
          // console.log(myData);
          return myData;
        }
        return buildHead() + buildBody();
      }
    },

    isRowExpandable: (dataIndex, expandedRows) => {
      ////
      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length < 0 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;

    },
    rowsExpanded: [],
    renderExpandableRow: (rowData, rowMeta) => {
      //
      let expandeditem = reportData.filter((value) => {
        return value.pdfFileName === rowData[4]
      })
      const colSpan = rowData.length + 1;
      return (
        <TableRow>

          <TableCell colSpan={colSpan}>
            <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
              <Table className={classes.tableLayout}>

                <TableRow style={{ backgroundColor: grey[400] }}>
                  <StyledTableCell >
                    REPORT DATE
                  </StyledTableCell>
                  <StyledTableCell >
                    SAMPLE NUMBER
                  </StyledTableCell>
                  <StyledTableCell >
                    EQUIPMENT DESCRIPTION
                  </StyledTableCell>
                  <StyledTableCell >
                    MAKE
                  </StyledTableCell>
                  <StyledTableCell >
                    MODEL
                  </StyledTableCell>
                  <StyledTableCell >
                    LO BRAND
                  </StyledTableCell>
                  <StyledTableCell >
                    STATUS
                  </StyledTableCell>

                </TableRow>

                <TableBody>
                  {expandeditem[0].EquipmentList?.map((item, index) => (
                    <TableRow>
                      <TableCell >{item.reportDt}</TableCell>
                      <TableCell >{item.SampleId}</TableCell>
                      <TableCell >{item.Equipment}</TableCell>
                      <TableCell >{item.Make}</TableCell>
                      <TableCell >{item.Model}</TableCell>
                      <TableCell >{item.lobrand}</TableCell>
                      <TableCell style={getFlagColor(item.status)}>{item.status}</TableCell>
                    </TableRow>

                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </TableCell>
        </TableRow >

      );
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
      console.log(curExpanded, allExpanded, rowsExpanded),
  };

  const getFlagColor = (status) => {
    var flagcls;
    switch (status) {
      case "Satisfactory":
        flagcls = {
          color: "#008000"
        };
        break;
      case "Critical":
        flagcls = {
          color: "red"
        };
        break;
      case "Warning":
        flagcls = {
          color: "#CA6F1E "
        };
        break;
      case "Other":
        flagcls = {
          color: "#73C6B6"
        };
        break;
      default:

    }
    return flagcls;

  };


  return (
    <div>
      <Dialog
        /*  fullWidth={} */
        maxWidth="xl"
        fullWidth
        maxWidth="sm"
        open={openpdf}
      //onClose={handleClose}

      >
        <DialogContent>
          {pdfURL ? (
            <iframe
              src={`${pdfURL}#page=1&toolbar=0`}
              //src={`${openBunkerAlerts}#page=1&toolbar=0&statusbar=0&scrollbar=1&height=100%`}
              // frameborder="0"
              // height={window.screen.height-280}
              width="100%"
              //  height={window.screen.height+"px"}
              // style={{"height":`${window.screen.height-280}px`}}
              style={{ "min-height": '100%' }, { "height": `${window.screen.height - 90}px` }}
            ></iframe>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <a href={`${pdfURL}#page=1&toolbar=0`} download={fName} style={{ textDecoration: "none" }}>
            <Tooltip title="Download"
              componentsProps={{
                tooltip: {
                  sx: {
                    color: "#1a1a31 ",
                    backgroundColor: "lightblue",
                    fontSize: "0.8em"
                  }
                }
              }}
            >
              <Button>Download</Button></Tooltip></a>
          <Button onClick={() => { handleClose(true) }}> <CancelIcon /></Button>
        </DialogActions>

      </Dialog>
      <Box component="main" px={3} pb={0} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box display="dlock">
              <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen} />} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box component="div" className="pos_relative">
        <Dialog
          open={openformFuel}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" color="white">Reports</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              //ref={descriptionElementRef}
              tabIndex={-1}
            >
              <p className="subtitle">Fuel Analysis</p><br />
              <p className="subtitle">Help On Filter Panel</p><br />
              <img className="maxwidth100" src="/assets/images/Report_Filter_Fuel_Analysis.jpg"></img><br /><br />
              <p>
                <li>Click and type on the fields to see the options</li><br />
                <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected options</li><br />
                <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                <li>Default reported date for fuel is 90days , and these default reported date can be changed manually</li>
              </p><br />
              <p className="subtitle">Help On Report Fuel Section</p><br />
              <img className="maxwidth100" src="/assets/images/Report_Status_Fuel_Analysis.jpg"></img><br /><br />
              <p>
                <li>Shows the No. of Report under the classification of </li>
                1.	Critical,<br />
                2.	Warning,<br />
                3.	Satisfactory,<br />
                4.	Other<br />
                Any Report without status of 1 to 3 will be grouped as "other"<br /><br />
                <li>Shows the No. of Reports of each of the service types of Fuel Analysis</li><br />
                <li>Click on the progress bar to display status based on the service type <img src={fuel_progressbar} alt="" width="200px" height="200px" /> </li>
              </p><br />
              <img className="maxwidth100" src="/assets/images/Report_Status_Table_Fuel_Analysis.jpg"></img><br /><br />
              <p>
                <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                <li>Click PDF icon <img src={pdficon} alt="" width="40px" height="40px" /> to open the file in PDF dialog box, on the dialog box right side bottom <img src={downloadpdf} alt="" width="100px" height="100px" />button to download file </li>
                <div className={classes.text}> as pdf document</div>
              </p>
              <br />
              <img className="maxwidth100" src="/assets/images/Report_Status_Table_Fuel_Analysis1.jpg"></img><br /><br />
              <p>
                <li>Select <CheckBoxIcon color="primary" /> to delete particular row and click <DeleteIcon color="action" /> on the top of the grid</li>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClickClose}>Close</Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={openformLube}
          //onClose={handleClickCloseLube}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" color="white">Reports</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              //ref={descriptionElementRef}
              tabIndex={-1} >
              <p className="subtitle">Lube Analysis</p><br />
              <p className="subtitle">Help On Filter Panel</p><br />
              <img className="maxwidth100" src="/assets/images/Report_page_lube_help_section1.jpg"></img><br /><br />
              <p>
                <li>Click and type on the fields to see the options</li><br />
                <li>For multiple selections hold <img src={ctrl} alt="" width="40px" height="40px" /> to select options from the list</li><br />
                <li>Click on <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                <li>Click on <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /></li><br />
                <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected options</li><br />
                <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                <li>Default reported date for lube is 180days , and these default reported date can be changed manually</li>
              </p><br />
              <p className="subtitle">Help On Report Lube Section</p><br />
              <img className="maxwidth100" src="/assets/images/Report_page_lube_help_section2.jpg"></img><br /><br />
              <p>
                <li>Shows the No. of Report under the classification of </li>
                1.	Critical,<br />
                2.	Warning,<br />
                3.	Satisfactory,<br />
                4.	Other<br />
                Any Report without status of 1 to 3 will be grouped as "other"<br /><br />
                <li>Shows the No. of Reports of each of the service types of lube Analysis</li><br />
                <li>Click on the progress bar to display status based on the service type <img src={lube_progressbar} alt="" width="200px" height="200px" /></li>
              </p><br />
              <img className="maxwidth100" src="/assets/images/Report_page_lube_help_section3.jpg"></img><br /><br />
              <p>
                <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                <li>Click PDF icon <img src={pdficon} alt="" width="40px" height="40px" /> to open the file in PDF dialog box, on the dialog box right side bottom <img src={downloadpdf} alt="" width="100px" height="100px" />button to download file </li>
                <div className={classes.text}> as pdf document</div><br />
                <li>Click <ArrowForwardIosIcon color="disabled" /> to see the particular ship details</li><br />
                <li>Click <ArrowForwardIosIcon color="disabled" sx={{ transform: "rotateZ(90deg)" }} /> to close the particular ship details</li>
              </p>
              <br />
              <img className="maxwidth100" src="/assets/images/Report_page_lube_help_section4.jpg"></img><br /><br />
              <p>
                <li>Select <CheckBoxIcon color="primary" /> to delete particular row and click <DeleteIcon color="action" /> on the top of the grid</li>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClickCloseLube}>Close</Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={openformTot}
          //onClose={handleClickCloseLube}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" color="white">Reports</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              //ref={descriptionElementRef}
              tabIndex={-1} >
              <p className="subtitle">VPS Power</p><br />
              <p className="subtitle">Help On Filter Panel</p><br />
              <img className="maxwidth100" src="/assets/images/Report_Filter_Transoil_Analysis.jpg"></img><br /><br />
              <p>
                <li>Click and type on the fields to see the options</li><br />
                <li>For multiple selections hold <img src={ctrl} alt="" width="40px" height="40px" /> to select options from the list</li><br />
                <li>Click on <ClearIcon color="disabled" /> to clear all the selection in a particular field <img src={clear} alt="" width="300px" height="300px" /></li><br />
                <li>Click on <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /></li><br />
                <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected options</li><br />
                <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                <li>Default reported date for VPS Power is 730days , and these default reported date can be changed manually</li>
              </p><br />
              <p className="subtitle">Help On Report VPS Power Section</p><br />
              <img className="maxwidth100" src="/assets/images/Report_Status_Transoil_Analysis.jpg"></img><br /><br />
              <p>
                <li>Shows the No. of Report under the classification of </li>
                1.	Critical,<br />
                2.	Warning,<br />
                3.	Satisfactory,<br />
                4.	Other<br />
                Any Report without status of 1 to 3 will be grouped as "other"<br /><br />
                <li>Shows the No. of Reports of each of the service types of VPS Power Analysis</li><br />
                <li>Click on the progress bar to display status based on the service type <img src={trans_progressbar} alt="" width="200px" height="200px" /> </li>
              </p><br />
              <img className="maxwidth100" src="/assets/images/Report_Table_Transoil_Analysis.jpg"></img><br /><br />
              <p>
                <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                <li>Click PDF icon <img src={pdficon} alt="" width="40px" height="40px" /> to open the file in PDF dialog box, on the dialog box right side bottom <img src={downloadpdf} alt="" width="100px" height="100px" />button to download file </li>
                <div className={classes.text}> as pdf document</div>
              </p>
              <br />
              <img className="maxwidth100" src="/assets/images/Report_Table_Transoil_Analysis1.jpg"></img><br /><br />
              <p>
                <li>Select <CheckBoxIcon color="primary" /> to delete particular row and click <DeleteIcon color="action" /> on the top of the grid</li>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClickCloseTot}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Box className="reports-filter" >
        <Box
          display="block"
          mx={4}
          my={3}
          bgcolor="#fff"
          boxShadow={1}
          borderRadius={4}
          component="div"
        >
          {reporSubType == "Fuel" ? (
            <FiltersReportFuel filterReportFual={filterReportFual} clearFilter={clearFilter} defaultDate={getDefaultFuelDate()} FormatClearFilter={FormatClearFilter} />) :
            ""}
          {reporSubType == "Lube" ? (
            <FiltersReportLube filterReportLube={filterReportLube} clearFilter={clearFilter} defaultDate={getDefaultLubeDate()} FormatClearFilter={FormatClearFilter} />) :
            ""}
          {reporSubType == "Tot" ? (
            <FiltersReportTot filterReportTot={filterReportTot} clearFilter={clearFilter} defaultDate={getDefaultTotDate()} FormatClearFilter={FormatClearFilter} />) :
            ""}
        </Box>
        <Box
          display="block"
          mx={4}
          my={3}
          py={2}
          px={3}
          bgcolor="#fff"
          boxShadow={1}
          borderRadius={4}
          component="div"
        >
          <Box display="flex" component="div">
            <Grid container>
              <Grid item xs={12} sm={12} md={5}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={11}>
                    <ReportFormat
                      type="ReportStatus"
                      key="ReportFormatPart"
                      clearBarSelection={clearBarSelection}
                      row={reportFormatActive || {}}
                      filterReportFual={filterReportFual}
                      filterReportLube={filterReportLube}
                      filterReportTot={filterReportTot}
                      DataName={DataName}
                      formObj={globalFilterObj}
                      isEmpty={isEmpty}
                      reportsubType={reporSubType}
                      clearFilter={clearFilter}
                      tab={tab}
                      ClearProgressBar={ClearProgressBar}
                      DataProgressBar={DataProgressBar}
                      Resetclearprogressbar={Resetclearprogressbar}
                    />
                  </Grid>
                </Grid>

              </Grid>
              <Grid item xs={12} sm={12} md={7}>
                <Box component="div" display="block">
                  <ReportStatus key="ReportDataPart"
                    reporSubType={reporSubType} tabActive={tabReportActive} dashtab={props.location.dashtab}
                    reportObj={reportDetailsList}
                    reportStatusDetails={reportDetailsList}
                    getChangedTab={getChangedTab} />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box display="block" mb={3} my={3} component="div" className="reportstablehead">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                className={classes.tableBody}
                data={reportData}
                columns={(grouping == "false" && reporSubType == "Lube" ? getGridHeader2(reporSubType) : getGridHeader3(reporSubType))}
                options={options}
                components={{ TableFilterList: CustomFilterList, }}
              />
            </ThemeProvider>
          </Box>
        </Box>
      </Box>
    </div>

  )

}